import {
  TableBody,
  TableCell,
  TableRow,
} from "@windmill/react-ui";
import useToggleDrawer from "hooks/useToggleDrawer";
import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
//internal import  

const HistoryTable = ({ data, isCheck, setIsCheck, currency, lang, isLoading, setIsLoading, history }) => {
  const {
    handleModalOpen,
    serviceId,
    handleUpdate,
    // Destructurer d'autres valeurs ou fonctions nécessaires depuis useToggleDrawer si besoin 
  } = useToggleDrawer();
  return (
    <>
  

      <TableBody>
        {data?.map((item, i) => (
          <TableRow key={i + 1}>
            <TableCell>
              <span className="text-sm">
                {item.admin.name}
              </span>

            </TableCell>
            <TableCell>
              <span className="text-sm">
                {item.action} 
              </span>
            </TableCell>
            <TableCell>
              <span className="text-sm">
                {item.description} 
              </span>
            </TableCell>
            <TableCell>
              <span className="text-sm">
                {format(new Date(item.created_at), 'dd MMM yyyy')}
                <div>{format(new Date(item.created_at), "HH:mm")}</div>
              </span>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default HistoryTable;
